import { render, staticRenderFns } from "./StudentLogin.vue?vue&type=template&id=d4ba5352&scoped=true"
import script from "./StudentLogin.vue?vue&type=script&lang=js"
export * from "./StudentLogin.vue?vue&type=script&lang=js"
import style0 from "./StudentLogin.vue?vue&type=style&index=0&id=d4ba5352&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ba5352",
  null
  
)

export default component.exports